<template>
    <div class="home">{{ name }}</div>
</template>

<script setup>
const name = 'Home';
</script>
